(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.recetteSwiper = {
    attach: function (context, settings) {
      once("recetteSwiper", ".swiper-recette-produit", context).forEach(function (element) {
        var that = $(element);

        new Swiper($(element)[0], {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 20,
          pagination: {
            el: $(".recette-intro").find(".swiper-pagination")[0],
            type: "fraction",
          },
          navigation: {
            nextEl: $(".recette-intro").find(".swiper-button-next")[0],
            prevEl: $(".recette-intro").find(".swiper-button-prev")[0],
          },
          breakpoints: {
            750: {
              slidesPerView: 1,
            },
          },
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
